import services from "@/http";
import * as types from "./mutation-types";
import * as storage from "../storage";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetTipos_instituicoes", data.data);
  dispatch("ActionSetPagination", data.meta);
  return data.data;
};

export const ActionFind = async (store, search) => {
  var tipos_instituicoes = {
    data: [],
    meta: {},
  };

  await services.tipos_instituicoes.get_all(search).then((res) => {
    tipos_instituicoes = res.data;
  });
  return tipos_instituicoes;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.tipos_instituicoes.show({ id: id }).then((res) => {
    dispatch("ActionSetTipo_instituicao", res.data.tipo_instituicao);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.tipos_instituicoes.store(payload).then((res) => {
    commit(types.SET_TIPO_INSTITUICAO, res.data.tipo_instituicao);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.tipos_instituicoes
    .update({ id: payload.id }, payload)
    .then((res) => {
      commit(types.SET_TIPO_INSTITUICAO, res.data.tipo_instituicao);
    });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.tipos_instituicoes.delete({ id: id }).then(() => {
    commit(types.SET_TIPO_INSTITUICAO, null);
  });
};

export const ActionSetTipos_instituicoes = ({ commit }, payload) => {
  commit(types.SET_TIPOS_INSTITUICOES, payload);
};

export const ActionSetTipo_instituicao = ({ commit }, payload) => {
  commit(types.SET_TIPO_INSTITUICAO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewTipo_instituicao = ({ commit }) => {
  let tipo_instituicao = {
    nome: "",
    descricao: "",
  };
  commit(types.SET_TIPO_INSTITUICAO, tipo_instituicao);
};

export const ActionToSelect = async ({ dispatch }, id) => {
  let response = storage.getTiposInstituicoesToSelect();
  if (!response || !response.length) {
    response = [];
    await services.tipos_instituicoes.to_select().then((res) => {
      response = res.data;
    });
    storage.setTiposInstituicoesToSelect(response);
  }
  return response;
};

export const ActionCategoriasToSelect = async () => {
  let response = [];

  await services.tipos_instituicoes.categorias_to_select().then((res) => {
    response = res.data;
  });

  return response;
};
